interface Correlation {
  tag: string
  symptom_type: string
  occurrences: number
  total: number
  percentage: number
  strength: string
}

interface HeroCorrelationCardProps {
  correlation: Correlation | null
}

function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function HeroCorrelationCard({ correlation }: HeroCorrelationCardProps) {
  if (correlation?.strength !== "strong") return null

  const symptomLabel = capitalize(correlation.symptom_type)

  return (
    <div
      className="hero-correlation rounded-2xl p-5"
      style={{
        background: "var(--fig-card-bg)",
        boxShadow: "var(--fig-card-shadow)",
        border: "1px solid var(--fig-card-border)",
      }}
    >
      <div className="mb-3 flex items-center gap-2">
        <div
          style={{
            width: 8,
            height: 8,
            borderRadius: 4,
            background: "var(--fig-hero-accent)",
          }}
        />
        <span
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: "var(--fig-hero-accent)",
            letterSpacing: "0.06em",
            textTransform: "uppercase",
          }}
        >
          Strong pattern
        </span>
      </div>

      <div className="mb-3 flex items-baseline gap-3">
        <span
          style={{
            fontFamily: "serif",
            fontSize: 48,
            fontWeight: 700,
            letterSpacing: "-0.03em",
            lineHeight: 1,
            color: "var(--fig-text-primary)",
          }}
        >
          {correlation.percentage}%
        </span>
        <div>
          <p style={{ fontSize: 15, fontWeight: 600, lineHeight: 1.3 }}>
            {symptomLabel} followed {correlation.tag}
          </p>
          <p style={{ fontSize: 13, color: "var(--fig-text-inactive)" }}>
            {correlation.occurrences} of {correlation.total} times
          </p>
        </div>
      </div>

      <p
        style={{
          fontSize: 13,
          color: "var(--fig-text-secondary)",
          lineHeight: 1.5,
        }}
      >
        Try skipping {correlation.tag} for a few days — you&apos;ll know
        quickly.
      </p>
    </div>
  )
}
